export const getLanguageSelector = (state) => state.language || "";
